import { createAsyncCategoryHandler } from "../category-dispatcher";
import { apiTools } from "./api-tools";
import { commentTools } from "./comment-tools";
import { folderTools } from "./folder-tools";
import { imageTools } from "./image-tools";
import { scheduledJobTools } from "./scheduled-job-tools";
import { workflowTools } from "./workflow-tools";

/**
 * Category handler for extended project operations.
 * Consolidates folder-tools, comment-tools, workflow-tools, scheduled-job-tools,
 * api-tools, image-tools, and role-tools handlers.
 */
export const handleProjectExtendedCategory = createAsyncCategoryHandler(
  {
    // Folders (all sync)
    list_folders: folderTools.sync!.ui_project_list_folders,
    create_folder: folderTools.sync!.ui_project_create_folder,
    rename_folder: folderTools.sync!.ui_project_rename_folder,
    delete_folder: folderTools.sync!.ui_project_delete_folder,
    add_item_to_folder: folderTools.sync!.ui_project_add_item_to_folder,
    remove_item_from_folder: folderTools.sync!.ui_project_remove_item_from_folder,
    create_subfolder: folderTools.sync!.ui_project_create_subfolder,
    rename_subfolder: folderTools.sync!.ui_project_rename_subfolder,
    delete_subfolder: folderTools.sync!.ui_project_delete_subfolder,
    add_item_to_subfolder: folderTools.sync!.ui_project_add_item_to_subfolder,
    remove_item_from_subfolder: folderTools.sync!.ui_project_remove_item_from_subfolder,

    // Workflows (sync)
    list_workflows: workflowTools.sync!.ui_project_list_workflows,
    list_actions: workflowTools.sync!.ui_project_list_actions,

    // Scheduled jobs (sync)
    list_scheduled_jobs: scheduledJobTools.sync!.ui_project_list_scheduled_jobs,

    // APIs (sync)
    list_apis: apiTools.sync!.ui_project_list_apis,
    get_api_details: apiTools.sync!.ui_project_get_api_details
  },
  {
    // Comments (all async)
    list_comments: commentTools.async!.ui_project_list_comments,
    post_comment: commentTools.async!.ui_project_post_comment,
    reply_to_comment: commentTools.async!.ui_project_reply_to_comment,

    // Workflows (async)
    navigate_to_workflow: workflowTools.async!.ui_project_navigate_to_workflow,
    create_workflow: workflowTools.async!.ui_project_create_workflow,
    delete_workflow: workflowTools.async!.ui_project_delete_workflow,
    duplicate_workflow: workflowTools.async!.ui_project_duplicate_workflow,

    // Scheduled jobs (async)
    navigate_to_scheduled_job: scheduledJobTools.async!.ui_project_navigate_to_scheduled_job,

    // APIs (async)
    navigate_to_api: apiTools.async!.ui_project_navigate_to_api,

    // Images (all async)
    list_images: imageTools.async!.ui_project_list_images,
    upload_image: imageTools.async!.ui_project_upload_image
  }
);
